import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fsDate'
})
export class FsDatePipe implements PipeTransform {
  public monthsShort: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  transform(value: number, allYears: boolean = false, noHours: boolean = false): any {
    const d: Date = new Date();
    const currentYear: number = d.getFullYear();
    d.setTime(value);
    const hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
    const minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
    const hoursMinutes = noHours ? '' : ' ' + hours + ':' + minutes;
    const ret = (allYears || currentYear !== d.getFullYear()) ?
      d.getDate() + ' ' + this.monthsShort[d.getMonth()] + ' ' + d.getFullYear() :
      d.getDate() + ' ' + this.monthsShort[d.getMonth()] + hoursMinutes;
    return ret;
  }

}
